module.exports = __webpack_public_path__ + "static/media/tera.bca9179c.jpeg";